export const isOpenRegistationFormPresentInUrl = () => {
  return window.location.href.includes("openRegistationForm") || window.location.href.includes("openRegistrationForm");
}